/**
 * @generated SignedSource<<d8a639c4a7913f398a042048ecc67871>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShareAccessAccountDrawerOrgMembersQuery$variables = {
  organizationId: string;
};
export type ShareAccessAccountDrawerOrgMembersQuery$data = {
  readonly organizationMembers: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly user: {
        readonly email: string;
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type ShareAccessAccountDrawerOrgMembersQuery = {
  response: ShareAccessAccountDrawerOrgMembersQuery$data;
  variables: ShareAccessAccountDrawerOrgMembersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "pagination",
        "value": {
          "page": 0,
          "pageSize": 1000000
        }
      }
    ],
    "concreteType": "OrganizationMemberPage",
    "kind": "LinkedField",
    "name": "organizationMembers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrganizationMember",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareAccessAccountDrawerOrgMembersQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShareAccessAccountDrawerOrgMembersQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "77c8b958baec7006606884d9bd63749f",
    "id": null,
    "metadata": {},
    "name": "ShareAccessAccountDrawerOrgMembersQuery",
    "operationKind": "query",
    "text": "query ShareAccessAccountDrawerOrgMembersQuery(\n  $organizationId: UUID!\n) {\n  organizationMembers(filter: {organizationId: $organizationId}, pagination: {page: 0, pageSize: 1000000}) {\n    nodes {\n      id\n      user {\n        id\n        email\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "806f0e6fb3e44ecb1577f622f46d9bfe";

export default node;
